import request from '@/common/request'

class ItemClienteVoNfService {
  getAllByAtualizacao(atualizacaoId, entradaOuSaida, params) {
    return request.get(
      `/itens-cliente-vo-notas-fiscais/atualizacoes/${atualizacaoId}/${entradaOuSaida}`,
      {
        params
      }
    )
  }

  calcularRegras(atualizacaoId) {
    return request.patch(`/itens-cliente-vo-notas-fiscais/dados/${atualizacaoId}`)
  }

  updateStatusConferencia(data) {
    return request.patch('/itens-cliente-vo-notas-fiscais', data)
  }
}

export default new ItemClienteVoNfService()
